



































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// service methods
import validate from "@/directives/validate";
// components
import vSelect from "vue-select";
// types
import { PMSettings } from "@/services/players/types";
import { settingsValidators } from "@/components/players/playerMonitorValidators";

@Component({
    components: {
        vSelect
    },
    directives: {
        validate
    }
})
export default class PlayerMonitorSettings extends Vue {
    @Prop() collapseState!: boolean;
    @Prop() settings!: PMSettings;

    // local state
    localCollapseState = true;
    localSettings = {} as PMSettings;
    validators = settingsValidators;

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
        this.localSettings = this.settings;
    }

    async created() {
    }

    // Watchers
    @Watch("settings")
    onPropertyChanged() {
        this.localSettings = this.settings;
    }

    // methods

    emitData() {
        this.$emit("settingsUpdated", this.localSettings);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "PlayerMonitorSettings.vue", state: state });
    }

    setMonitorAllPlayersProp(value: boolean) {
        this.localSettings.monitorAllPlayers = value;
        this.emitData();
    }
}
